import { createContext } from 'react';
import { useEmployeeForm } from '../hooks/useEmployeeForm'

export const EmployeeFormContext = createContext(null);

export const EmployeeFormContextProvider = ({ children }) => {

    const employeeFormContext = useEmployeeForm();

    return (
        <EmployeeFormContext.Provider value={employeeFormContext}>
            {children}
        </EmployeeFormContext.Provider>
    )
}
